export default {
    US: {
        postCodeRegex: /^\d{5}(-\d{4})?$/,
    },
    CA: {
        postCodeRegex: /[a-zA-Z]\d[a-zA-Z] \d[a-zA-Z]\d$/,
    },
    CO: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    AR: {
        postCodeRegex: /[a-zA-Z]\d\d\d\d[a-zA-Z]{3}$|^\d\d\d\d$/,
    },
    AU: {
        postCodeRegex: /^\d\d\d\d$/,
    },
    AT: {
        postCodeRegex: /^\d\d\d\d$/,
    },
    BE: {
        postCodeRegex: /^\d\d\d\d$/,
    },
    BN: {
        postCodeRegex: /[a-zA-Z][a-zA-Z]\d\d\d\d$/,
    },
    CH: {
        postCodeRegex: /^\d\d\d\d$/,
    },
    CL: {
        postCodeRegex: /^\d{7}$/,
    },
    CZ: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    DE: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    DK: {
        postCodeRegex: /^\d{4}$/,
    },
    ES: {
        postCodeRegex: /^(?!5100[0-5]|51070|51071|51081|5200[0-6]|5207[0-1]|52081)\d{5}$/,
    },
    FI: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    FR: {
        postCodeRegex: /^([0-8]\d{4}|9[0-6,9]\d{3})$/,
    },
    GB: {
        postCodeRegex: /^[a-zA-Z][a-zA-Z]?\d[a-zA-Z\d]?\s\d[a-zA-Z]{2}$/,
    },
    HU: {
        postCodeRegex: /^\d\d\d\d$/,
    },
    ID: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    IE: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    IL: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    IS: {
        postCodeRegex: /^\d{3}$/,
    },
    IT: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    JP: {
        postCodeRegex: /^\d{3}(-\d{4})$/,
        illegalCharactersRegex: /^([\u30A0-\u30FF]|[\u3000-\u303F]|[a-zA-Z0-9\\s\\.!\\\\/:@#&*-’, ]|[\u4E00-\u9FAF]|[\uFF00-\uFFEE]|[\u3040-\u309F]|\\s)*$/,
    },
    KR: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    LU: {
        postCodeRegex: /^\d\d\d\d$/,
    },
    MX: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    MY: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    NC: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    NL: {
        postCodeRegex: /^\d{4}[A-Z]{2}$/,
    },
    NO: {
        postCodeRegex: /^\d\d\d\d$/,
    },
    NZ: {
        postCodeRegex: /^\d\d\d\d$/,
    },
    PF: {
        postCodeRegex: /^987\d\d$/,
    },
    PE: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    PH: {
        postCodeRegex: /^\d\d\d\d$/,
    },
    PL: {
        postCodeRegex: /^\b\d{5}\b$|\d{2}-\d{3}$/,
    },
    PT: {
        postCodeRegex: /^\d{7}$/,
    },
    RO: {
        postCodeRegex: /^\d{6}$/,
    },
    RU: {
        postCodeRegex: /^\d{6}$/,
    },
    SE: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    SG: {
        postCodeRegex: /^\d{6}$/,
    },
    SK: {
        postCodeRegex: /^\d{3}\d{2}$/,
    },
    TH: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    TR: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    UA: {
        postCodeRegex: /^\d\d\d\d\d$/,
    },
    ZA: {
        postCodeRegex: /^\d\d\d\d$/,
    },
};
